// import React, { useEffect } from 'react';
// import { motion } from 'framer-motion';
// import './Tenders.css';
// import { useLanguage } from '../context/LanguageContext';

// /* Scroll-reveal hook */
// const useScrollReveal = (selector, options = {}) => {
//   useEffect(() => {
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in-view'); });
//     }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px', ...options });
//     document.querySelectorAll(selector).forEach(el => observer.observe(el));
//     return () => observer.disconnect();
//   }, [selector]);
// };

// const Tenders = () => {
//   const { t } = useLanguage();

//   const tenders = [
//     {
//       id: 1,
//       nameKey: 'tenders.tenderItems.bhaktaNiwas.name',
//       descKey: 'tenders.tenderItems.bhaktaNiwas.description',
//       costKey: 'tenders.tenderItems.bhaktaNiwas.estimatedCost',
//       statusKey: 'tenders.tenderItems.bhaktaNiwas.status',
//       deadlineKey: 'tenders.tenderItems.bhaktaNiwas.deadline'
//     },
//     {
//       id: 2,
//       nameKey: 'tenders.tenderItems.annaKshetra.name',
//       descKey: 'tenders.tenderItems.annaKshetra.description',
//       costKey: 'tenders.tenderItems.annaKshetra.estimatedCost',
//       statusKey: 'tenders.tenderItems.annaKshetra.status',
//       deadlineKey: 'tenders.tenderItems.annaKshetra.deadline'
//     },
//     {
//       id: 3,
//       nameKey: 'tenders.tenderItems.gardenDevelopment.name',
//       descKey: 'tenders.tenderItems.gardenDevelopment.description',
//       costKey: 'tenders.tenderItems.gardenDevelopment.estimatedCost',
//       statusKey: 'tenders.tenderItems.gardenDevelopment.status',
//       deadlineKey: 'tenders.tenderItems.gardenDevelopment.deadline'
//     },
//     {
//       id: 4,
//       nameKey: 'tenders.tenderItems.gauShala.name',
//       descKey: 'tenders.tenderItems.gauShala.description',
//       costKey: 'tenders.tenderItems.gauShala.estimatedCost',
//       statusKey: 'tenders.tenderItems.gauShala.status',
//       deadlineKey: 'tenders.tenderItems.gauShala.deadline'
//     }
//   ];

//   useScrollReveal('.reveal');

//   return (
//     <motion.div 
//       className="tenders-page"
//       initial={{ opacity: 0, x: 20 }}
//       animate={{ opacity: 1, x: 0 }}
//       transition={{ duration: 0.5 }}
//     >

//       {/* ── CINEMATIC HERO ── */}
//       <div className="tenders-hero">
//         <div className="tenders-hero-bg" />
//         <div className="tenders-hero-overlay" />
//         <div className="tenders-hero-rays" aria-hidden="true">
//           {[1,2,3,4,5].map(i => <span key={i} className={`hero-ray hero-ray-${i}`} />)}
//         </div>
//         <div className="tenders-hero-content">
//           <span className="page-hero-pill">{t('tenders.pageTitle')}</span>
//           <h1 className="page-hero-title">{t('tenders.pageSubtitle')}</h1>
//           <div className="page-hero-divider">
//             <span className="phd-line" /><span className="phd-diamond">◆</span><span className="phd-line" />
//           </div>
//         </div>
//         <div className="page-hero-bottom-line" />
//       </div>


//       {/* ── PAGE BODY ── */}
//       <div className="container">
//         <section className="tenders-section reveal">
//           <div className="tenders-intro">
//             <p>{t('tenders.intro')}</p>
//           </div>

//           <div className="tenders-grid">
//             {tenders.map((tender, index) => {
//               const statusValue = t(tender.statusKey).toLowerCase().replace(' ', '-');
//               return (
//                 <div key={tender.id} className="tender-card reveal" style={{ '--stagger-index': index }}>
//                   <div className="tender-header">
//                     <h3>{t(tender.nameKey)}</h3>
//                     <span className={`status-badge ${statusValue}`}>
//                       {t(tender.statusKey)}
//                     </span>
//                   </div>

//                   <p className="tender-description">{t(tender.descKey)}</p>

//                   <div className="tender-details">
//                     <div className="detail-item">
//                       <span className="detail-label">{t('tenders.estimatedCost')}</span>
//                       <span className="detail-value">{t(tender.costKey)}</span>
//                     </div>
//                     <div className="detail-item">
//                       <span className="detail-label">{t('tenders.deadline')}</span>
//                       <span className="detail-value">{t(tender.deadlineKey)}</span>
//                     </div>
//                   </div>

//                   <div className="tender-actions">
//                     <button className="tender-btn download">
//                       {t('tenders.downloadPDF')}
//                     </button>
//                     <button className="tender-btn inquiry">
//                       {t('tenders.contactForInquiry')}
//                     </button>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           <div className="tender-contact-info reveal">
//             <h3>{t('tenders.tendersQueriesTitle')}</h3>
//             <div className="contact-details">
//               <p>
//                 {t('tenders.email_label')}: <a href={`mailto:${t('tenders.email_val')}`}>{t('tenders.email_val')}</a>
//               </p>
//               <p>
//                 {t('tenders.phone_label')}: <a href={`tel:+919876543210`} className="simple-font">{t('tenders.phone_val')}</a>
//               </p>
//               <p>
//                 {t('tenders.officeHours_label')}: {t('tenders.officeHours_val')}
//               </p>
//             </div>
//           </div>
//         </section>
//       </div>
//     </motion.div>
//   );
// };

// export default Tenders;










import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import './Tenders.css';
import { useLanguage } from '../context/LanguageContext';

/* Scroll-reveal hook */
const useScrollReveal = (selector, options = {}) => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in-view'); });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px', ...options });
    document.querySelectorAll(selector).forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, [selector]);
};

const Tenders = () => {
  const { t } = useLanguage();

  const tenders = [
    {
      id: 1,
       pdf: "/pdf/Construction_of_Devotee_Residence_Tender.pdf",
      nameKey:     'tenders.tenderItems.bhaktaNiwas.name',
      descKey:     'tenders.tenderItems.bhaktaNiwas.description',
      costKey:     'tenders.tenderItems.bhaktaNiwas.estimatedCost',
      statusKey:   'tenders.tenderItems.bhaktaNiwas.status',
      deadlineKey: 'tenders.tenderItems.bhaktaNiwas.deadline'
    },
    {
      id: 2,
       pdf: "/pdf/Food_Sector_Expansion_Tender.pdf",
      nameKey:     'tenders.tenderItems.annaKshetra.name',
      descKey:     'tenders.tenderItems.annaKshetra.description',
      costKey:     'tenders.tenderItems.annaKshetra.estimatedCost',
      statusKey:   'tenders.tenderItems.annaKshetra.status',
      deadlineKey: 'tenders.tenderItems.annaKshetra.deadline'
    },
    {
      id: 3,
      pdf: "/pdf/Open_Park_Development_Tender",
      nameKey:     'tenders.tenderItems.gardenDevelopment.name',
      descKey:     'tenders.tenderItems.gardenDevelopment.description',
      costKey:     'tenders.tenderItems.gardenDevelopment.estimatedCost',
      statusKey:   'tenders.tenderItems.gardenDevelopment.status',
      deadlineKey: 'tenders.tenderItems.gardenDevelopment.deadline'
    },
    {
      id: 4,
        pdf: "/pdf/Gaushala_Modernization_Tender",
      nameKey:     'tenders.tenderItems.gauShala.name',
      descKey:     'tenders.tenderItems.gauShala.description',
      costKey:     'tenders.tenderItems.gauShala.estimatedCost',
      statusKey:   'tenders.tenderItems.gauShala.status',
      deadlineKey: 'tenders.tenderItems.gauShala.deadline'
    }
  ];

  useScrollReveal('.tender-scroll-item');
  useScrollReveal('.tender-contact-scroll');

  return (
    <motion.div
      className="tenders-page"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
    >

      {/* ── CINEMATIC HERO ── */}
      <div className="tenders-hero">
        <div className="tenders-hero-bg" />
        <div className="tenders-hero-overlay" />
        <div className="tenders-hero-rays" aria-hidden="true">
          {[1,2,3,4,5].map(i => <span key={i} className={`tenders-ray tenders-ray-${i}`} />)}
        </div>
        <div className="tenders-hero-content">
          <span className="tenders-hero-pill-pill">{t('tenders.pageTitle')}</span>
          <h1 className="tenders-hero-title">{t('tenders.pageSubtitle')}</h1>
          <div className="tenders-hero-divider">
            <span className="thd-line" />
            <span className="thd-diamond">◆</span>
            <span className="thd-line" />
          </div>
        </div>
        <div className="tenders-hero-bottom-line" />
      </div>

      {/* ── PAGE BODY ── */}
      <div className="container">

        {/* Intro — parchment scroll */}
        <section className="tenders-intro-section">
          <div className="tenders-intro-parchment">
            <div className="tenders-intro-content">
              <h2 className="tenders-intro-title">{t('tenders.pageSubtitle')}</h2>
              <div className="parchment-divider" />
              <p >{t('tenders.intro')}</p>
            </div>
          </div>
        </section>

        {/* Tenders Grid — each card is a parchment scroll */}
        <section className="tenders-grid-section">
          <h2 className="section-title">{t('tenders.pageTitle')}</h2>
          <div className="tenders-header-divider">
            <span className="dot" /><span className="line" /><span className="dot" />
          </div>
          <div className="tenders-grid">
            {tenders.map((tender, index) => {
              const statusValue = t(tender.statusKey).toLowerCase().replace(' ', '-');
              return (
                <div className="tender-scroll-item" key={tender.id}>
                  <div className="tender-scroll-content">

                    {/* Title + Status */}
                    <div className="tender-scroll-header">
                      <h3>{t(tender.nameKey)}</h3>
                      {/* <span className={`status-badge ${statusValue}`}>
                        {t(tender.statusKey)}
                      </span> */}
                    </div>

                    <div className="parchment-divider" />

                    {/* Description */}
                    <p >{t(tender.descKey)}</p>

                    {/* Cost + Deadline */}
                    <div className="tender-details">
                      <div className="detail-item">
                        <span className="detail-label">{t('tenders.estimatedCost')}</span>
                        <span >{t(tender.costKey)}</span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">{t('tenders.deadline')}</span>
                        <span c>{t(tender.deadlineKey)}</span>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="tender-actions">
                      {/* <button className="tender-btn download">
                        {t('tenders.downloadPDF')}
                      </button> */}
                      <a
    href={tender.pdf}
    download
    target="_blank"
    rel="noopener noreferrer"
    className="tender-btn download"
  >
    {t('tenders.downloadPDF')}
  </a>
                      <button className="tender-btn inquiry">
                        {t('tenders.contactForInquiry')}
                        {/* koditnathmhaskoba63@gmail.com */}
                      </button>
                    </div>

                  </div>
                </div>
              );
            })}
          </div>
        </section>

        {/* Contact Info — parchment scroll */}
        <section className="tender-contact-section">
          <div className="tender-contact-scroll">
            <div className="tender-contact-inner">
              <h3 className="tender-contact-title">{t('tenders.tendersQueriesTitle')}</h3>
              <div className="parchment-divider" />
              <div className="contact-details">
                <p>
                  {t('tenders.email_label')}:{' '}
                  <a href={`mailto:${t('tenders.email_val')}`}>{t('tenders.email_val')}</a>
                </p>
                <p>
                  {t('tenders.phone_label')}:{' '}
                  <a href="tel:+919876543210">{t('tenders.phone_val')}</a>
                </p>
                <p>
                  {t('tenders.officeHours_label')}: {t('tenders.officeHours_val')}
                </p>
              </div>
            </div>
          </div>
        </section>

      </div>
    </motion.div>
  );
};

export default Tenders;